'use strict';

const { h } = require('phy');

const { getImageSource } = require('../../../support/logo-image-helper');

function getImageSources({ data, sourceProperties }) {
  if (!sourceProperties) {
    return [];
  }

  return sourceProperties.map(image =>
    h('source', {
      media: `(max-width: ${image.media}px)`,
      srcset: getImageSource({ data, size: image.size }),
    })
  );
}

function MerchantLogoImage({
  className = '',
  alt,
  data = [],
  size,
  sourceProperties,
  lazyload = true,
  conquestOffer,
}) {
  const imageSource = getImageSource({ data, size, conquestOffer });

  if (!imageSource) {
    return null;
  }

  const imageSources = getImageSources({ data, sourceProperties });

  const imageTags = lazyload
    ? {
        src:
          'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
        'data-src': imageSource,
        class: `lazy-load no-bg ${className}`,
      }
    : {
        src: imageSource,
        class: className,
      };

  return h('picture', [
    ...imageSources,
    h('img', {
      ...imageTags,
      alt,
      width: size.width,
      height: size.height,
    }),
  ]);
}

module.exports = MerchantLogoImage;
